module.exports = __webpack_public_path__ + "NeueFrutigerWorld-Medium.837625a0b5251ead93e1.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-Medium.ttf
// module id = ../../../../../src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-Medium.ttf
// module chunks = styles